import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getDocuments as getDocumentsApi,
  addNewDocument as addNewDocumentApi,
  updateDocument as updateDocumentApi,
  deleteDocument as deleteDocumentApi,
  getArchives as getArchivesApi,
  addNewArchive as addNewArchiveApi,
  updateArchive as updateArchiveApi,
  deleteArchive as deleteArchiveApi,
  getFolders as getFoldersApi,
  addNewFolder as addNewFolderApi,
  deleteFolder as deleteFolderApi,
} from "../../helpers/realbackend_helper";

export const getDocuments = createAsyncThunk(
  "document/getDocuments",
  async () => {
    try {
      const response = await getDocumentsApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addNewDocument = createAsyncThunk(
  "document/addNewDocument",
  async (doc) => {
    try {
      const response = addNewDocumentApi(doc);
      toast.success("Бичиг баримт амжилттай бүртгэлээ", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Бичиг баримт бүртгэхэд алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateDocument = createAsyncThunk(
  "document/updateDocument",
  async (doc) => {
    try {
      const response = updateDocumentApi(doc);
      toast.success("Бичиг баримт амжилттай засварлалаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Бичиг баримт засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const deleteDocument = createAsyncThunk(
  "document/deleteDocument",
  async (id, { rejectWithValue }) => {
    try {
      await deleteDocumentApi(id);

      toast.success("Бичиг баримт амжилттай устгалаа", {
        autoClose: 3000,
      });

      return { id };
    } catch (error) {
      toast.error("Бичиг баримт устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });

      return rejectWithValue({
        error: error.response?.data?.message || error.message,
      });
    }
  }
);

//======================= Archives ==================================

export const getArchives = createAsyncThunk(
  "document/getArchives",
  async () => {
    try {
      const response = await getArchivesApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addNewArchive = createAsyncThunk(
  "document/addNewArchive",
  async (doc) => {
    try {
      const response = addNewArchiveApi(doc);
      toast.success("Архивын бичиг баримт амжилттай бүртгэлээ", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Архивын бичиг баримт бүртгэхэд алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateArchive = createAsyncThunk(
  "document/updateArchive",
  async (doc) => {
    try {
      const response = updateArchiveApi(doc);
      toast.success("Архивын бичиг баримт амжилттай засварлалаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Архивын бичиг баримт засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const deleteArchive = createAsyncThunk(
  "document/deleteArchive",
  async (id, { rejectWithValue }) => {
    try {
      await deleteArchiveApi(id);

      toast.success("Архивын бичиг баримт амжилттай устгалаа", {
        autoClose: 3000,
      });

      return { id };
    } catch (error) {
      toast.error("Архивын бичиг баримт устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });

      return rejectWithValue({
        error: error.response?.data?.message || error.message,
      });
    }
  }
);

//======================= Archive Folders ==================================

export const getFolders = createAsyncThunk(
  "document/getFolders",
  async ({ category, department } = {}, { rejectWithValue }) => {
    try {
      const response = await getFoldersApi({ category, department });
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const addNewFolder = createAsyncThunk(
  "document/addNewFolder",
  async (data, { rejectWithValue }) => {
    try {
      const response = await addNewFolderApi(data);
      toast.success("Хавтас амжилттай үүслээ", { autoClose: 3000 });
      return response;
    } catch (error) {
      const msg = error.response?.data?.message || "Хавтас үүсгэхэд алдаа гарлаа";
      toast.error(msg, { autoClose: 3000 });
      return rejectWithValue({ error: msg });
    }
  }
);

export const deleteFolder = createAsyncThunk(
  "document/deleteFolder",
  async (id, { rejectWithValue }) => {
    try {
      await deleteFolderApi(id);
      toast.success("Хавтас устгалаа", { autoClose: 3000 });
      return id;
    } catch (error) {
      toast.error("Хавтас устгахад алдаа гарлаа", { autoClose: 3000 });
      return rejectWithValue({ error: error.message });
    }
  }
);
